import {
  FullGrowerRole,
  getProductCategoryBySlug,
  isRealProductCategoryKey,
  realProductCategories,
  RealProductCategoryKey,
} from "@rooted/shared";
import { Card, Menu } from "antd";
import classNames from "classnames";
import React from "react";
import { Link, Route, Routes, useLocation, useParams } from "react-router-dom";
import { PageHeader } from "../../../components/PageHeader";
import { ProductGrid } from "../../../components/ProductGrid";
import { CollapsingSider } from "../../../components/Sider/CollapsingSider";
import { NotFoundPage, PageContent, WideLayout } from "../../../views/layouts";
import { ListingDetails } from "./ListingDetails";
import { AddInventory } from "./AddInventory";
import { GrowerInventoryOverview } from "./InventoryOverview";

const growerCategories: RealProductCategoryKey[] = [
  "cut-flower",
  "bucket",
  "bouquet",
  "dried-flower",
  "wreath",
  "potted-plant",
  "csa",
];

export const InventoryOverviewByCategory: React.FC = () => {
  const { slug } = useParams();
  const category = getProductCategoryBySlug(slug);

  if (!category || !isRealProductCategoryKey(category.id)) {
    return <NotFoundPage />;
  }

  return <GrowerInventoryOverview category={category.id} />;
};

export const AddInventoryByCategory: React.FC = () => {
  const { slug } = useParams();
  const category = getProductCategoryBySlug(slug);

  if (!category || !isRealProductCategoryKey(category.id)) {
    return <NotFoundPage />;
  }

  return <AddInventory category={category.id} />;
};

export const GrowerInventory: React.FC<{ role: FullGrowerRole }> = ({ role }) => {
  const category = useLocation().pathname.split("/")[2] || "overview";

  return (
    <>
      <WideLayout>
        <CollapsingSider
          smallDrawerLabel={{ selection: category, title: "Product Type" }}
          hideIfSmall={category === "overview"}
          selectedKeys={[category]}
        >
          {growerCategories.map((category) => (
            // URL uses plural, so this makes the highlight work
            <Menu.Item key={`${category}s`}>
              <Link to={realProductCategories[category].slug}>
                {realProductCategories[category].pluralName}{" "}
              </Link>
            </Menu.Item>
          ))}
        </CollapsingSider>
        <PageContent>
          <Routes>
            <Route path=":slug" element={<InventoryOverviewByCategory />} />
            <Route path=":slug/add-inventory" element={<AddInventoryByCategory />} />
            <Route path=":slug/:listingId" element={<ListingDetails />} />
            <Route path="" element={<InventoryOverview />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </PageContent>
      </WideLayout>
    </>
  );
};

export const InventoryOverview: React.FC = () => {
  return (
    <>
      <PageHeader title="Inventory"></PageHeader>
      <ProductGrid>
        {growerCategories.map((category) => (
          <Link
            key={category}
            to={realProductCategories[category].slug}
            style={{ display: "inline-block" }}
          >
            <Card
              className={classNames("overview-card")}
              style={{
                backgroundImage: `url("/images/${category}.jpg")`,
              }}
            >
              <div className="overview-card-overlay">
                {realProductCategories[category].pluralName}
              </div>
            </Card>
          </Link>
        ))}
      </ProductGrid>
    </>
  );
};
